import * as React from "react";
const SvgSimpleFiligreeSendToPhotographer = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-acb1f8c1-fd58-4ce1-905f-d8e259abd1a9", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 94.23 57.56", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: ".55 15.64 93.39 .99 59.77 54.25 45.53 44.67 28.79 33.4 29.9 56.56 17.4 26.63 .55 15.64", style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("polyline", { points: "17.4 26.63 93.39 .99 28.79 33.4", style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("line", { x1: 29.9, y1: 56.56, x2: 45.53, y2: 44.67, style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeWidth: 2
} }));
export default SvgSimpleFiligreeSendToPhotographer;
